export default __webpack_public_path__ + "static/media/sponsor3.44d7d697.png";